const BaseComponent = require('base/base-component');
const Server = require('helper/server');

module.exports = class extends BaseComponent {
  init () {
    this.$num = this.$el.find('.num');
    this.$href = this.$el.find('a.btn');
    this.fetchData();
  }

  fetchData () {
    Server.getCMSData('expertCount').then((resp) => {
      const data = typeof resp == 'string' ? JSON.parse(resp) : resp;
      const {
        data_response: { count = 0, url = 'https://experts.zcygov.cn/expert/register' }
      } = data;
      const total = count;
      this.$num.text(total);
      this.$href.attr('href', url);
    });
  }
};
